// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__1yl0E","input":"Input_input__3zmkf","label":"Input_label__3Rdpy","error":"Input_error__1B0LT"};